import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import classNames from 'fg-frontend/src/lib/classNames';

const fragments = {
  TAB: '[data-fragment="Tabs.tab"]',
  SLIDER: '[data-fragment="Tabs.slider"]',
  PANE: '[data-fragment="Tabs.pane"]',
};

export default class Tabs extends WebComponent {
  constructor(props) {
    super(props);
    this.state = {
      sliderWidth: 0,
      sliderLeft: 0,
      activeTab: null,
      activePane: null,
    };
  }
  didMount() {
    this.on('click', fragments.TAB, this.handleClickAction);
    this.slider = this.element.querySelector(fragments.SLIDER);
    this.tabs = this.element.querySelectorAll(fragments.TAB);
    this.panes = this.element.querySelectorAll(fragments.PANE);
    for (let i = 0; i < this.tabs.length; i++) {
      if (this.tabs[i].classList.contains('tabs__nav-item--active')) {
        this.setState({
          activeTab: this.tabs[i],
        });
        setTimeout(() => {
          this.setState({
            sliderWidth: this.tabs[i].clientWidth,
            sliderLeft: this.tabs[i].offsetLeft,
          });
        }, 50);
      }
    }
    for (let i = 0; i < this.panes.length; i++) {
      if (this.panes[i].classList.contains('tabs__pane--active')) {
        this.setState({
          activePane: this.panes[i],
        });
      }
    }
    window.addEventListener('resize', this.onResize.bind(this));
  }
  handleClickAction = (e) => {
    setTimeout(() => {
      window.setMatrixHeight();
    },100);
    this.setState({
      activeTab: e.target,
    });
    setTimeout(() => {
      this.setState({
        sliderWidth: e.target.clientWidth,
        sliderLeft: e.target.offsetLeft,
      });
    }, 50);
    for (let i = 0; i < this.panes.length; i++) {
      if (this.panes[i].getAttribute('id') === e.target.dataset.target) {
        this.setState({
          activePane: this.panes[i],
        });
      }
    }
  };
  onResize() {
    this.setState({
      sliderWidth: this.state.activeTab.clientWidth,
      sliderLeft: this.state.activeTab.offsetLeft,
    });
  }
  update() {
    const { activeTab, sliderWidth, sliderLeft, activePane } = this.state;
    for (let i = 0; i < this.tabs.length; i++) {
      this.tabs[i].classList.remove('tabs__nav-item--active');
    }
    for (let i = 0; i < this.panes.length; i++) {
      this.panes[i].classList.remove('tabs__pane--active');
    }
    classNames(activeTab, {
      'tabs__nav-item--active': true,
    });
    classNames(activePane, {
      'tabs__pane--active': true,
    });
    this.slider.style.width = `${sliderWidth}px`;
    this.slider.style.left = `${sliderLeft}px`;
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/Tabs.js